import React from 'react';
import {
  arrayOf, object, oneOfType, shape, string
} from 'prop-types';
import './size-table.scss';

export const SizeTable = ({ measurements, sizes }) => {
  return (
    <table className="size-table">
      <thead>
        <tr>
          <th>
            <span className="size-table__title">
              Bedding Type
            </span>
          </th>
          {/* eslint-disable-next-line react/no-danger,jsx-a11y/control-has-associated-label */}
          {sizes.map((size, sizeIndex) => <th key={sizeIndex} dangerouslySetInnerHTML={{ __html: size }} />
          )}
        </tr>
      </thead>
      <tbody>
        {measurements.map((measurement, measurementIndex) => {
          return (
            <tr key={measurementIndex}>
              <td>
                {measurement.type}
              </td>
              {measurement.values.map((value, valueIndex) => <td key={valueIndex}>{ value }</td>)}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

SizeTable.displayName = 'SizeTable';

SizeTable.propTypes = {
  sizes: arrayOf(string).isRequired,
  measurements: arrayOf(shape({
    type: string,
    values: arrayOf(oneOfType([string, object]))
  })).isRequired
};
